import { useLocation } from "react-router-dom";
import Page from "src/components/Report/Page";

export default function Page8() {
    let translate = {
        0: "بی اهمیت",
        1: "کم اهمیت",
        2: "لازم",
        3: "نسبتا ضروری",
        4: "ضروری",
        5: "خیلی ضروری"
    }

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const jobId = params.get("id");

    let education;
    let experience;
    if (JSON.parse(localStorage?.data)?.[jobId]?.education) {
        education = JSON.parse(localStorage?.data)?.[jobId]?.education;
        // console.log(education);
        Object.keys(education).map((key, index) => {
            if (education[key]) {
                education = key;
            }
        })
    } else {
        education = "";
    }
    if (JSON.parse(localStorage?.data)?.[jobId]?.experience) {
        experience = JSON.parse(localStorage?.data)?.[jobId]?.experience;
        Object.keys(experience).map((key, index) => {
            if (experience[key]) {
                experience = key;
            }
        })
    } else {
        experience = "";
    }

    let reshteTahsili;
    if (JSON.parse(localStorage?.data)?.[jobId]?.reshteTahsili) {
        reshteTahsili = JSON.parse(localStorage?.data)?.[jobId]?.reshteTahsili;
    } else {
        reshteTahsili = [];
    }


    let vijegihayeJesmi;
    if (JSON.parse(localStorage?.data)?.[jobId]?.vijegihayeJesmi) {
        vijegihayeJesmi = JSON.parse(localStorage?.data)?.[jobId]?.vijegihayeJesmi;
    }



    let formFieldSalahiatha;
    if (JSON.parse(localStorage?.data)?.[jobId]?.formFieldSalahiatha) {
        formFieldSalahiatha = JSON.parse(localStorage?.data)?.[jobId]?.formFieldSalahiatha;
    } else {
        formFieldSalahiatha = [];
    }
    return (
        <Page pageNumber={8}>
            <div className="font-bold text-lg">
                شرایط احراز پایه:
            </div>
            <p className="text-black text-justify">
                شرایط احراز پایه شامل حداقل الزامات تحصیلی، تجربی و مهارتی است که فرد برای تصدی شغل باید دارا باشد. این شرایط معمولاً شامل مدرک تحصیلی مرتبط، سابقه کاری مشخص، و توانمندی‌های جسمی یا روانی ضروری برای انجام وظایف شغلی هستند. تعیین دقیق این الزامات به انتخاب شایسته‌ترین افراد کمک می‌کند. همچنین مبنایی برای طراحی مسیرهای ارتقاء و آموزش کارکنان فراهم می‌سازد.
            </p>
            <div className="flex flex-col gap-6">
                <div>
                    <div className="w-full flex bg-[#5b5cff] text-white justify-between rounded">
                        <div className="p-2 w-full flex items-center justify-center text-center border border-solid border-white rounded">
                            حداقل تحصیلات
                        </div>
                        <div className="p-2 w-full flex items-center justify-center text-center border border-solid border-white rounded">
                            میزان سابقه
                        </div>
                    </div>
                    <div className="w-full flex bg-gray-200 text-gray-800 justify-between rounded">
                        <div className="p-2 w-full flex items-center justify-center text-center border border-solid border-white rounded">
                            {education}
                        </div>
                        <div className="p-2 w-full flex items-center justify-center text-center border border-solid border-white rounded">
                            {experience}
                        </div>
                    </div>
                </div>
                <div className="flex items-center rounded gap-2 border border-gray-200 border-solid bg-gray-100">
                    <div className="bg-[#5b5cff] flex-grow w-[250px] h-[80px] rounded flex justify-center items-center text-white p-2"> رشته‌های تحصیلی مرتبط</div>
                    <div className="text-gray-800  p-2 w-full">
                        {reshteTahsili.map(function (single) {
                            return single.value;
                        }).join(", ")}
                    </div>
                </div>

                {
                    vijegihayeJesmi ?
                        <div className="flex">
                            <div style={{ whiteSpace: "nowrap" }} className="bg-[#5b5cff] w-[60px] flex justify-center items-center text-white rounded p-2">
                                <span className="flex justify-center items-center rotate-90 w-full">ویژگی‌های جسمی مورد نیاز</span>
                            </div>
                            <div className="w-full flex flex-col">
                                <div className="flex">
                                    <div className="w-full">
                                        <div className="border-l border-solid border-gray-400 flex flex-col gap-2 justify-center items-center rounded w-full bg-gray-200">
                                            <div className="flex flex-col justify-center items-center gap-2 p-2">
                                                <span>بینایی</span>
                                                <img src="./assets/img/eye.png" className="w-[60px]" />
                                            </div>
                                            <div className="bg-gray-300 w-full flex justify-center items-center p-2">{translate[vijegihayeJesmi["بینایی کامل"].value]}</div>
                                        </div>
                                    </div>
                                    <div className="w-full">
                                        <div className="border-l border-solid border-gray-400 flex flex-col gap-2 justify-center items-center rounded w-full bg-gray-200">
                                            <div className="flex flex-col justify-center items-center gap-2 p-2">
                                                <span>شنوایی</span>
                                                <img src="./assets/img/deaf.png" className="w-[60px]" />
                                            </div>
                                            <div className="bg-gray-300 w-full flex justify-center items-center p-2">{translate[vijegihayeJesmi["شنوایی"].value]}</div>
                                        </div>
                                    </div>
                                    <div className="w-full">
                                        <div className="border-l border-solid border-gray-400 flex flex-col gap-2 justify-center items-center rounded w-full bg-gray-200">
                                            <div className="flex flex-col justify-center items-center gap-2 p-2">
                                                <span>بویایی</span>
                                                <img src="./assets/img/aroma.png" className="w-[60px]" />
                                            </div>
                                            <div className="bg-gray-300 w-full flex justify-center items-center p-2">{translate[vijegihayeJesmi["بویایی"].value]}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex">
                                    <div className="w-full">
                                        <div className="border-l border-solid border-gray-400 flex flex-col gap-2 justify-center items-center rounded w-full bg-gray-200">
                                            <div className="flex flex-col justify-center items-center gap-2 p-2">
                                                <span>قدرت بدنی</span>
                                                <img src="./assets/img/muscles.png" className="w-[60px]" />
                                            </div>
                                            <div className="bg-gray-300 w-full flex justify-center items-center p-2">{translate[vijegihayeJesmi["قدرت بدنی"].value]}</div>
                                        </div>
                                    </div>
                                    <div className="w-full">
                                        <div className="border-l border-solid border-gray-400 flex flex-col gap-2 justify-center items-center rounded w-full bg-gray-200">
                                            <div className="flex flex-col justify-center items-center gap-2 p-2">
                                                <span>عدم نقص عضو</span>
                                                <img src="./assets/img/disability.png" className="w-[60px]" />
                                            </div>
                                            <div className="bg-gray-300 w-full flex justify-center items-center p-2">{translate[vijegihayeJesmi["عدم نقص عضو"].value]}</div>
                                        </div>
                                    </div>
                                    <div className="w-full">
                                        <div className="border-l border-solid border-gray-400 flex flex-col gap-2 justify-center items-center rounded w-full bg-gray-200">
                                            <div className="flex flex-col justify-center items-center gap-2 p-2">
                                                <span>تکلم و قدرت بیان</span>
                                                <img src="./assets/img/speak.png" className="w-[60px]" />
                                            </div>
                                            <div className="bg-gray-300 w-full flex justify-center items-center p-2">{translate[vijegihayeJesmi["تکلم و قدرت بیان"].value]}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex">
                                    <div className="w-full">
                                        <div className="border-l border-solid border-gray-400 flex flex-col gap-2 justify-center items-center rounded w-full bg-gray-200">
                                            <div className="flex flex-col justify-center items-center gap-2 p-2">
                                                <span>دویدن</span>
                                                <img src="./assets/img/running.png" className="w-[60px]" />
                                            </div>
                                            <div className="bg-gray-300 w-full flex justify-center items-center p-2">{translate[vijegihayeJesmi["دویدن"].value]}</div>
                                        </div>
                                    </div>
                                    <div className="w-full">
                                        <div className="border-l border-solid border-gray-400 flex flex-col gap-2 justify-center items-center rounded w-full bg-gray-200">
                                            <div className="flex flex-col justify-center items-center gap-2 p-2">
                                                <span>تشخیص رنگ‌ها</span>
                                                <img src="./assets/img/art.png" className="w-[60px]" />
                                            </div>
                                            <div className="bg-gray-300 w-full flex justify-center items-center p-2">{translate[vijegihayeJesmi["تشخیص رنگ‌ها"].value]}</div>
                                        </div>
                                    </div>
                                    <div className="w-full">
                                        <div className="border-l border-solid border-gray-400 flex flex-col gap-2 justify-center items-center rounded w-full bg-gray-200">
                                            <div className="flex flex-col justify-center items-center gap-2 p-2">
                                                <span>تناسب اندام</span>
                                                <img src="./assets/img/warming.png" className="w-[60px]" />
                                            </div>
                                            <div className="bg-gray-300 w-full flex justify-center items-center p-2">{translate[vijegihayeJesmi["تناسب اندام"].value]}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        null
                }
            </div>
            <p className="rounded-lg p-4 text-justify">
                همانطور که مشخص است در این شغل ‌به ترتیب موارد ‌
                <span className="text-gray-800">
                    {vijegihayeJesmi &&
                        Object.keys(vijegihayeJesmi).sort(function (a, b) { return vijegihayeJesmi[b].value - vijegihayeJesmi[a].value }).map((key, index) => {
                            // if (index < 2) {
                            return (key) + "، "
                            // }
                        })}
                </span>
                از بالاترین تا کمترین اهمیت برخوردارند

            </p>
            <div className="font-bold text-lg">
                صلاحیت‌های حرفه‌ای :
            </div>
            <p className="text-black text-justify">
                صلاحیت‌های حرفه‌ای شامل مجموعه‌ای از توانمندی‌ها، دانش تخصصی، و رفتارهای حرفه‌ای مورد نیاز برای انجام مؤثر وظایف شغلی است. این صلاحیت‌ها بر پایه استانداردهای شغلی، الزامات قانونی، و انتظارات سازمانی تعریف می‌شوند. ارزیابی و توسعه این صلاحیت‌ها نقش کلیدی در ارتقاء کیفیت عملکرد و مسیر رشد شغلی دارد. درج این بخش، مبنایی برای آموزش، ارزیابی و انتخاب افراد شایسته فراهم می‌سازد.
            </p>
            <div className="flex flex-col">
                {Object.keys(formFieldSalahiatha).map((key, index) => {
                    if (key.includes("صلاحیت")) {

                        return (<span className="odd-color" key={index}>{formFieldSalahiatha[key]}</span>)
                    }
                })}
            </div>

        </Page>
    )
}